import { ResponsiveContainer } from "recharts";
import Slider from "react-slick";
import { memo, useCallback, useMemo } from "react";

import "./SupportRow.scss";
import Container from "../../../../../component/container/Container";
import { redirectToPage } from "../../../../../service/utils/functions";
import SupportForm from "../../../../../component/support-form/SupportForm";

interface SupportRowProps {
  suggestionsArray: any[];
  currentPage: number;
  supportUsername: string;
  supportEmail: string;
  eventbriteBanner: string;
  eventbriteTitle: string;
  eventbriteEventLink: string;
  sliderRef: React.MutableRefObject<Slider | null>;

  setCurrentPage: (page: number) => void;

  width: number;
  darkMode: boolean;
}

const SupportRow = memo((props: SupportRowProps) => {
  const achiCarouselSettings = useMemo(
    () => ({
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      afterChange: (current: number) => {
        const newPage = Math.floor(current / 3);
        props.setCurrentPage(newPage);
      },
    }),
    [props]
  );
  const pagesNo = Math.ceil(props.suggestionsArray.length / 3);
  const sliderWidth =
    props.width < 1023 ? props.width - 100 : props.width * 0.245;

  const handleChangePage = useCallback(
    (idx: number) => {
      if (props.sliderRef.current) {
        const sliderNo = idx * 3 + 2;
        props.sliderRef.current.slickGoTo(sliderNo);
      }
    },
    [props.sliderRef]
  );
  const handleSuggestionClick = useCallback(
    (elem: any) => redirectToPage(elem.linkUrl),
    []
  );

  return (
    <div className="row">
      <Container
        title="Ways to improve"
        darkTheme={props.darkMode}
        pagesNo={pagesNo}
        currentPage={props.currentPage}
        onChangePage={handleChangePage}
      >
        <ResponsiveContainer>
          <div className="slider-container" style={{ width: sliderWidth }}>
            <Slider
              ref={(slider) => (props.sliderRef.current = slider)}
              {...achiCarouselSettings}
            >
              {props.suggestionsArray.map((elem, idx) => (
                <div key={"suggestion-" + idx}>
                  <div
                    className="grid-element"
                    onClick={() => handleSuggestionClick(elem)}
                  >
                    <div
                      className="grid-img"
                      style={{
                        backgroundImage: "url(" + elem.image + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <div className="grid-paragraph">
                      <p className="title">{elem.title}</p>
                      <p title={elem.description}>{elem.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </ResponsiveContainer>
      </Container>
      <Container title="Need Help?" darkTheme={props.darkMode}>
        <SupportForm
          username={props.supportUsername}
          email={props.supportEmail}
          darkMode={props.darkMode}
        />
      </Container>
      <div
        className={
          "eventbrite-banner-wrapper" + (props.darkMode ? " dark" : "")
        }
      >
        <a
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            aspectRatio: "16/9",
            backgroundImage: "url(" + props.eventbriteBanner + ")",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
          }}
          title={props.eventbriteTitle}
          href={props.eventbriteEventLink}
          target="_blank"
          rel="noreferrer"
        />
      </div>
    </div>
  );
});

export default SupportRow;
